import * as AppActions from './components/containers/App/actions';

export default {
  ...AppActions
};
